// extracted by mini-css-extract-plugin
export default {"title":"AdditionalContactClientForm_title__DgOte","buttonAdd":"AdditionalContactClientForm_buttonAdd__qOKpw","iconDelete":"AdditionalContactClientForm_iconDelete__SeFnZ"};